import script from "./ParentComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentComponent.vue?vue&type=script&setup=true&lang=js"

import "./ParentComponent.vue?vue&type=style&index=0&id=10dde4af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10dde4af"]])

export default __exports__